export default "__VITE_ASSET__G3lKpoWM__"